export const FIELDS = {
  'Deb-Nr': 'id',
  // Zusatzkenntnisse
  'Scheit-T': 'Scheitholzheiztechnik',
  'Hack-T': 'Hackschnitzelheiztechnik',
  'P-Öfen': 'Pelletöfen',
  // Kategorien
  FPK: 'Fachbetrieb Pelletkaminofen',
  PFB: 'Pelletfachbetrieb',
  // Infos
  Ort: 'Ort',
  Straße: 'Straße',
  PLZ: 'PLZ',
  Internet: 'Internet',
  'Email-Adresse': 'email',
  Telefon: 'Telefon',
  // Technikschulung
  Unterstützerfirma: 'Unterstützerfirma',
  // DUNNO
  'Firma 1': 'Firma 1',
  'Firma 2': 'Firma 2',
};

export const parseCompanies = (company, zips) => {
  const zip = zips[company['PLZ'].trim()];
  if (!zip) return company;
  const location = zip.point;
  return {
    ...company,
    location,
  };
};
